import { api } from "./api";
import { clerkClient } from "@/App";
import { useQuery } from "@tanstack/react-query";
import type { SensorResponse } from "./sensor-types";

// Re-export types for convenience
export type { SensorResponse } from "./sensor-types";

/**
 * Fetch all sensors accessible to the current user
 * Returns an array of SensorResponse
 */
export const fetchSensors = async (): Promise<SensorResponse[]> => {
  const authToken = await clerkClient.session?.getToken();
  if (!authToken) {
    throw new Error("Authentication required");
  }
  const res = await api.get<SensorResponse[]>("/sensors", {
    headers: { Authorization: `Bearer ${authToken}` },
  });
  return res.data;
};

/**
 * Fetch a single sensor by slug or id
 * @param slugOrId - Either a slug (string) or numeric id (number)
 */
export const fetchSensor = async (slugOrId: string | number): Promise<SensorResponse> => {
  const authToken = await clerkClient.session?.getToken();
  if (!authToken) {
    throw new Error("Authentication required");
  }
  const res = await api.get<SensorResponse>(`/sensors/${slugOrId}`, {
    headers: { Authorization: `Bearer ${authToken}` },
  });
  return res.data;
};

// React Query hooks

export const useSensorsQueryV1 = () => {
  return useQuery({
    queryKey: ["sensors", "v1"],
    queryFn: fetchSensors,
  });
};

export const useSensorQueryV1 = (slugOrId: string | number) => {
  return useQuery({
    queryKey: ["sensor", "v1", slugOrId],
    queryFn: () => fetchSensor(slugOrId),
    enabled: !!slugOrId || slugOrId === 0,
  });
};

